"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_LIST = void 0;
exports.blurStatusForNextFocus = blurStatusForNextFocus;
exports.default = reducer;
exports.loadCurrent = loadCurrent;
exports.meterReadError = meterReadError;
exports.onDropDownClick = onDropDownClick;
exports.paginate = paginate;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _meterReadingApi = require("../api/meterReadingApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT = 'api/reducer/METER_READ';
var PAGINATE = 'reducer/METER_READ/PAGINATE';
var ERROR_LIST = exports.ERROR_LIST = 'reducer/METER_READ/ERROR_LIST';
var BLUR_STATUS = 'reducer/METER_READ/BLUR_STATUS';
var CLICK_STATUS = 'reducer/METER_READ/CLICK_STATUS';
var ERROR_HINT = 'reducer/METER_READ/ERROR_HINT';

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_CURRENT:
      return {
        state: state,
        action: action.data.innerData,
        currentPageId: action.data.currentPageId
      };
    case PAGINATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPageId: action.data.currentPageId
      });
    case ERROR_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorObj: action.data.errorObj
      });
    case BLUR_STATUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        blurStatus: action.data.blurStatus
      });
    case CLICK_STATUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        clickStatus: action.data.clickStatus
      });
    case ERROR_HINT:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorHint: {
          code: action.data.code,
          args: action.data.args
        }
      });
    default:
      return state;
  }
}

// Action Creators
function loadCurrent(dispatch, currentPage) {
  var resp = (0, _meterReadingApi.getMeterReadingData)();
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT,
      data: {
        currentPageId: currentPage,
        innerData: reponse.data.content
      }
    });
  }).catch(function (err) {
    var _err$response, _err$response$data, _err$response$data$er, _err$response2, _err$response2$data, _err$response2$data$e;
    dispatch({
      type: ERROR_HINT,
      data: {
        code: err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$er = _err$response$data.errors[0]) === null || _err$response$data$er === void 0 ? void 0 : _err$response$data$er.code,
        args: err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$e = _err$response2$data.errors[0]) === null || _err$response2$data$e === void 0 ? void 0 : _err$response2$data$e.args
      }
    });
  });
}
function paginate(dispatch, currentPage) {
  dispatch({
    type: PAGINATE,
    data: {
      currentPageId: currentPage
    }
  });
}
function meterReadError(dispatch, errorObj) {
  dispatch({
    type: ERROR_LIST,
    data: {
      errorObj: errorObj
    }
  });
}
function blurStatusForNextFocus(dispatch, blurStatus) {
  dispatch({
    type: BLUR_STATUS,
    data: {
      blurStatus: blurStatus
    }
  });
}
function onDropDownClick(dispatch, clickStatus) {
  dispatch({
    type: CLICK_STATUS,
    data: {
      clickStatus: clickStatus
    }
  });
}